import React from "react";
import { Stack } from "@mui/material";
import SkillsAnimationProgress from "./SkillsAnimationProgress";

function SkillsProgress(props) {
  const { skills } = props;
  return (
    <>
      <Stack
        sx={{
          width: "100%",
        }}
        spacing={6}
      >
        {skills
          .sort((a, b) => parseInt(b.progressValue) - parseInt(a.progressValue))
          .map((skill) => (
            <SkillsAnimationProgress
              key={skill.skillName}
              skillName={skill.skillName}
              color={skill.progressColor}
              value={parseInt(skill.progressValue)}
            />
          ))}
      </Stack>
    </>
  );
}

export default SkillsProgress;
